import { useCallback, useEffect } from 'react';
import { GoogleMap } from '@react-google-maps/api';
import { 
  mapContainerStyle, 
  ringRoadBounds, 
  minZoom,
  defaultZoom
} from '../../lib/map/constants';
import { logDebug } from '../../lib/map/utils';

interface GoogleMapComponentProps {
  isLoaded: boolean;
  onLoad: (map: google.maps.Map) => void;
  onClick: (e: google.maps.MapMouseEvent) => void;
  onDragEnd: () => void;
}

export const GoogleMapComponent: React.FC<GoogleMapComponentProps> = ({
  isLoaded,
  onLoad,
  onClick,
  onDragEnd
}) => {
  if (!isLoaded) {
    return null;
  }

  // Check if mapId exists in environment variables
  const mapId = import.meta.env.VITE_GOOGLE_MAPS_ID || '';

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={defaultZoom}
      onLoad={onLoad}
      onClick={onClick}
      onDragEnd={onDragEnd}
      options={{
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: window.google?.maps.ControlPosition.RIGHT_TOP
        },
        clickableIcons: false,
        draggableCursor: 'grab',
        draggingCursor: 'grabbing',
        mapId: mapId, // Use mapId if available
        gestureHandling: 'greedy',
        disableDefaultUI: false,
        minZoom: minZoom,
        maxZoom: 18,
        draggable: true
        // Note: Removed styles property since it can't be used with mapId
        // If you need map styling, configure it via Google Cloud Console using the mapId
      }}
    />
  );
}; 